import { LOCALE } from "core/interfaces";

import { extractTranslation } from "~/common/helpers/extract-translation";
import type { Kind, KindAdapted } from "~/common/interfaces/entities/kind.interface";

export const kindDenormalize = (kindAdapted: KindAdapted): Kind => {
	const { name: _name, namePlural: _namePlural, ...rest } = kindAdapted;

	return {
		...rest
	};
};

export const kindNormalize = (locale: Ref<LOCALE>, kind: Kind): KindAdapted => {
	const { translations, ...rest } = kind;

	const translation = extractTranslation(locale.value, translations);

	return {
		name: translation ? translation.name : "NAME",
		namePlural: translation ? translation.namePlural : "NAME_PLURAL",
		translations,
		...rest
	};
};
